import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-charcoal text-champagne" data-testid="site-footer">
      <div className="container-wide py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="font-serif text-2xl md:text-3xl tracking-tight">
              2 ON Capital
            </Link>
            <p className="mt-6 text-champagne/60 font-sans font-light text-sm leading-relaxed max-w-md">
              A global holding platform operating across real assets, markets, and enterprise. 
              Headquartered in Dubai, United Arab Emirates.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-sans uppercase tracking-[0.2em] text-champagne/40 mb-6">
              Navigate
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/about" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                About
              </Link>
              <Link to="/portfolio" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                Global Portfolio
              </Link>
              <Link to="/philosophy" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                Investment Philosophy
              </Link>
              <Link to="/legacy" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                Legacy & Vision
              </Link>
            </nav>
          </div>

          {/* Regions */}
          <div>
            <h4 className="text-xs font-sans uppercase tracking-[0.2em] text-champagne/40 mb-6">
              Regions
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/portfolio/uae" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                United Arab Emirates
              </Link>
              <Link to="/portfolio/uk" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                United Kingdom
              </Link>
              <Link to="/portfolio/pakistan" className="text-sm text-champagne/70 hover:text-champagne transition-colors duration-300">
                Pakistan
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-champagne/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-champagne/40 font-mono">
            Dubai, United Arab Emirates
          </p>
          <p className="text-xs text-champagne/40 font-mono">
            © {new Date().getFullYear()} 2 ON Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
